import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { waLink } from "./utils";

export const WO_STATUS = {
  da_fare: { label: "Da fare", chip: "bg-[#FEE2E2] text-[#991B1B]", dot: "bg-[#DC2626]", btn: "bg-[#DC2626]" },
  in_lavorazione: { label: "In lavorazione", chip: "bg-[#DBEAFE] text-[#1E40AF]", dot: "bg-[#2563EB]", btn: "bg-[#2563EB]" },
  pronto: { label: "Pronto", chip: "bg-[#EDE9FE] text-[#5B21B6]", dot: "bg-[#7C3AED]", btn: "bg-[#7C3AED]" },
  ritirato: { label: "Ritirato", chip: "bg-[#DCFCE7] text-[#166534]", dot: "bg-[#16A34A]", btn: "bg-[#15803D]" },
};
export const WO_KEYS = Object.keys(WO_STATUS);
export const eur = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(+n || 0);
export const dt = (s) => new Date(s).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export async function woNotify(o, channel, done) {
  const win = channel === "whatsapp" ? window.open("", "_blank") : null;
  try {
    const { data } = await api.post(`/admin/work-orders/${o.id}/notify`, { channel });
    if (win) win.location.href = waLink(o.client.phone, data.text);
    toast.success(channel === "email" ? `Email inviata a ${o.client.email}` : "WhatsApp aperto con il messaggio pronto");
    done?.();
  } catch (e) { win?.close(); toast.error(errMsg(e)); }
}

export async function woOpenFile(o, i) {
  const win = window.open("", "_blank");
  try {
    const r = await api.get(`/admin/work-orders/${o.id}/file/${i}`, { responseType: "blob" });
    win.location.href = URL.createObjectURL(r.data);
  } catch (e) { win?.close(); toast.error(errMsg(e)); }
}
